import { render } from "./Recipes.vue?vue&type=template&id=af0c5748&scoped=true"
import script from "./Recipes.vue?vue&type=script&lang=js"
export * from "./Recipes.vue?vue&type=script&lang=js"

import "./Recipes.vue?vue&type=style&index=0&id=af0c5748&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af0c5748"]])

export default __exports__